import axios from "axios";
import { getStore } from "./storeAccessor";
import { refreshToken, logout } from "../redux_files/authSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000",
});

// ✅ interceptor لإضافة التوكن من Redux لكل الطلبات
api.interceptors.request.use(
  (config) => {
    const state = getStore().getState();
    const token = state.auth?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ interceptor لتجديد التوكن عند 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const state = getStore().getState();
      const refresh = state.auth?.refresh;

      if (refresh) {
        try {
          const res = await axios.post(
            `${
              process.env.REACT_APP_API_URL || "http://localhost:8000"
            }/api/token/refresh/`,
            { refresh }
          );

          getStore().dispatch(refreshToken(res.data));

          originalRequest.headers.Authorization = `Bearer ${res.data.access}`;
          return api(originalRequest);
        } catch (refreshError) {
          getStore().dispatch(logout());
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
